var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.parentId
        ? [
            _c("q-alert", { attrs: { color: "primary", type: "warning" } }, [
              _vm._v("Please save this company before creating comments.")
            ])
          ]
        : [
            _c(
              "div",
              [
                _c("q-input", {
                  ref: "input",
                  attrs: {
                    type: "textarea",
                    "float-label": "Add " + _vm.resource,
                    after: [
                      {
                        icon: "add",
                        content: true,
                        handler: _vm.addHandler
                      }
                    ]
                  },
                  model: {
                    value: _vm.newValue,
                    callback: function($$v) {
                      _vm.newValue = $$v
                    },
                    expression: "newValue"
                  }
                })
              ],
              1
            ),
            _c("br"),
            _c("br"),
            _vm.value && _vm.value.length && _vm.titleColumn
              ? _c(
                  "q-list",
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-2 text-right" },
                      [
                        _c("q-btn", {
                          staticClass: "no-shadow",
                          attrs: { icon: "unfold_more", align: "right" },
                          on: { click: _vm.expandAll }
                        }),
                        _c("q-btn", {
                          staticClass: "no-shadow",
                          attrs: { icon: "unfold_less", align: "right" },
                          on: { click: _vm.collapseAll }
                        })
                      ],
                      1
                    ),
                    _c("br"),
                    _vm._l(_vm.value, function(item) {
                      return _c(
                        "q-collapsible",
                        {
                          key: item.id,
                          ref: "collapsible",
                          refInFor: true,
                          attrs: {
                            label: _vm._f("niceDate")(
                              _vm._f("relationLabel")(item, _vm.titleColumn)
                            ),
                            subtitle: _vm._f("relationLabel")(
                              item,
                              _vm.subtitleColumn
                            )
                          }
                        },
                        _vm._l(_vm.infoColumns, function(column, columnIndex) {
                          return _c(
                            "div",
                            { key: columnIndex, staticClass: "infoColumn" },
                            [_vm._v(_vm._s(item[column.field]))]
                          )
                        }),
                        0
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }